const InitInput = {
  industry: null,
  pdc: null,
  sv_family: null,
  machine_type: null,
  h1: null,
  h2: null,
  h3: null,
  configuration: null,
  l_r_angle: null,
  max_angle_center: null,
  max_angle_50mm_inner: null,
  track: null,
  l1_extension: null,
  l2: null,
  l2_value: null,
  lower_end_double_bend: false,
  special_le_slope: null,
  u1_extension: null,
  column_top_extension: null,
  return_channel: null,
  special_return: null,
  u2: null,
  u2_value: null,
  upper_end_double_bend: false,
  nbr_windings: null,
  product_tbh: [],
  pdp: [],
  product_flow: null,
  slat_type: null,
  belt_guide: null,
  hf_fl_ratio: null,
  transport_direction: null,
  outside_guide_type: null,
  inside_guide_type: null,
  outside_guide_height: null,
  side_guides_adjusted_for_transport: null,
  outer_guide_mounted_on_site: null,
  inside_guide_height: null,
  offset_inside: null,
  offset_outside: null,
  offset_le_inside: null,
  offset_le_outside: null,
  offset_ue_inside: null,
  offset_ue_outside: null,
  return_channel_le: null,
  frame_material: null,
  support_frame_material: null,
  feet: null,
  support_frame: null,
  chemical_anchor_capsules: null,
  closed_bottom_column: null,
  floor_support_le: null,
  floor_support_rc: null,
  b_guide_connector_plate_ue_le: null,
  chain_material: null,
  shaft_sprockets_bearing: null,
  guide_plate: false,
  mechanical_isolation_class: null,
  thermostatic_isolation_class: null,
  thermistor: null,
  motor_mounting_position: null,
  motor_mounting_orientation: null,
  oil_drip_pan: null,
  safety_cover: null,
  drive_for_special_country: null,
  drive_country: null,
  extra_service_access: null,
  chain_service_distance_under_ue: null,
  clear_inspection_panel: null,
  chain_service_distance_from_le_horizontal: null,
  chinese_manual: null,
  english_manual: null,
  english_manual_purchase_office: null,
  dutch_manual: null,
  german_manual: null,
  french_manual: null,
  spanish_manual: null,
  italian_manual: null,
  japanese_manual: null,
  korean_manual: null,
  slovene_manual: null,
  polish_manual: null,
  portuguese_manual: null,
  manual_box_60_inch_above_floor: null,
  gearmotor_type: null,
  voltage_movimot: null,
  voltage_50_hz: null,
  voltage_60_hz: null,
  customized_voltage: null,
  voltage_delta_87_hz: null,
  earthing: null,
  motor_colour: null,
  frame_finishing: null,
  frame_colour: null,
  brake_motor: null,
  brake: null,
  brake_voltage: null,
  drive_connector: null,
  belt_guide_rollers_material: null,
  transfer_side: null,
  le_transfer_side: null,
  ue_transfer_side: null,
  product_transfer: null,
  knife_belt_transfer_position: null,
  waterfall_transfer_height: null,
  waterfall_transfer_length: null,
  krones_transition_preparation: null,
  krones_transition_rollerbed_le: null,
  krones_transition_rollerbed_ue: null,
  rounded_edge_knife_connection: null,
  customized_transition: null,
  extra_name_plate: null,
  ce_certification: null,
  noise_measurement_report: null,
  ce2b_declaration: null,
  ce2b_declaration_language: null,
  ambaflex_sticker: null,
  material_package: null,
  product_max_length: null,
  digital_spare_part_list_en: null,
  sparepart_list_excel: null,
  digital_manual_en: null,
  digital_manual_du: null,
  digital_manual_fr: null,
  digital_manual_ge: null,
  digital_manual_it: null,
  digital_manual_sp: null,
  digital_manual_ch: null,
  digital_manual_ja: null,
  digital_manual_ko: null,
  digital_manual_sln: null,
  digital_manual_pl: null,
  digital_manual_pt: null,
  underguarding: null,
  transport_orientation: null,
  lifting_eye_top_column: null,
  frequency_inverter: null,
  frequency_inverter_interface: null,
  customized_frequency_inverter_interface: null,
  packaging_support: null,
  chain_overlength_detection: null,
  ul_certification: null,
  torque_arm: null,
  torque_arm_for_drive_type: null,
  function: null,
  column_type: null,
  friction_type: null,
  banking: null,
  banking_angle: null,
  track_build_in: null,
  return_channel_guarding: null,
  speed_range: null,
  centerline_speed: null,
  closure_gap: null,
  closure_gap_nbr_profile: null,
  closure_gap_option: null,
  manual_on_usb_stick: null,
  number_pdp: null,
  lubrication_type: null,
  lubrication_location: null,
  missing_slat_tab_sensor: null,
  alert_connection: null,
  maintenance_alert_system_location: null,
  maintenance_alert_system_distance_beneath_upper_end: null,
  junction_box_location: null,
  junction_box_location_distance_beneath_upper_end: null,
  sensor_brackets_infeed_outfeed: null,
  jam_detection_sensor: null,
  frame_top_column_netting: null,
  mounting_brackets_outer_diam: null,
  monitoring_12_month: null,
  gearmotor_hosting_device: null,
  gearmotor_food_grade_oil: null,
  special_corrosion_protection: null,
  gearmotor_shaft_removed_shipping: null,
  sliced_column_windings: null,
  distance_split_above_le: null,
  sliced_column_below_le: null,
  distance_flanged_plinth_below_le: null,
  chop_off_windings: null,
  chop_off_le: null,
  chop_off_ue_direct_return: null,
  chop_off_ue_extended_return: null,
  connection_machine_le: null,
  machine_ref_le: null,
  connection_machine_ue: null,
  machine_ref_ue: null,
  frequency: null,
  stainless_steel_drive: null,
  drive: {},
  drive_type: null,
  chain_overlength_detection_outside_drive_shaft: null,
  drive_region: null,
  ml_pre_treatment: null,
  connection_conveyor: [],
  nbr_divert_option_static_arm: null,
  nbr_divert_option_linear_arm: null,
  nbr_divert_option_swing_arm_electric: null,
  nbr_divert_option_swing_arm: null,
  ml_connection: null,
  nbr_merge_connection_bridge: null,
  nbr_divert_connection_bridge: null,
  nbr_ml_mounting_kit: null,
  nbr_ml_heavy_duty: null,
  nbr_ml_compact: null,
  divert_steering_components: null,
  power_supply_box_elec_swing_arm_conn_bridge: null,
  connection_bridge_disassembled_transport: null,
  long_side_leading: null,
  region: null,
  unit_system: null,
  crm_info: { user_level: 'IAM' },
};

export default InitInput;
